const middleware = {}

middleware['localization-loader'] = require('../middleware/localization-loader.js')
middleware['localization-loader'] = middleware['localization-loader'].default || middleware['localization-loader']

export default middleware
